import { z } from 'zod';

export const ApiErrorBody = z.object({
  error: z.object({
    code: z.string(),
    message: z.string().optional(),
    user_message: z.string().optional(),
    request_id: z.string().optional(),
    trace_id: z.string().optional(),
    details: z
      .object({
        required_points: z.number().int().nonnegative().optional(),
        available_points: z.number().int().nonnegative().optional(),
        field: z.string().optional(),
        reason: z.string().optional(),
        issues: z
          .array(
            z.object({
              path: z.string().optional(),
              code: z.string().optional(),
              message: z.string().optional(),
            }),
          )
          .optional(),
      })
      .passthrough()
      .optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBody>;
